
import Nav from "./nav"
import Slider from "./slider"
import Animation from "./animation"

document.addEventListener("DOMContentLoaded", function () {

    Nav(jQuery)
    Slider(jQuery)
    Animation(jQuery)
})
